import { render, staticRenderFns } from "./DraftContent.vue?vue&type=template&id=2d29fb8b&scoped=true"
import script from "./DraftContent.vue?vue&type=script&lang=js"
export * from "./DraftContent.vue?vue&type=script&lang=js"
import style0 from "./DraftContent.vue?vue&type=style&index=0&id=2d29fb8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29fb8b",
  null
  
)

export default component.exports